import * as actionTypes from './actionTypes';

export const removeSingleBet=(bet)=>({
    type:actionTypes.REMOVE_SINGLE_BET,
    payload:bet
})